import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    target: String
  };

  connect() {
    this.setupIntersectionObserver();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupIntersectionObserver() {
    const targetElement = document.querySelector(this.targetValue);
    if (!targetElement) return;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1 // Trigger when at least 10% of the form is visible
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Form is visible, hide the button
          this.element.classList.add("hidden");
        } else {
          // Form is not visible, show the button
          this.element.classList.remove("hidden");
        }
      });
    }, options);

    this.observer.observe(targetElement);
  }

  scroll() {
    const targetElement = document.querySelector(this.targetValue);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}

